import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function RolePermission(props) {
    const { component, pageName } = props;
    const navigate = useNavigate();
    const getRoleByPermission = useSelector((state) => state?.selectedActiveView?.getRoleByPermission);

    // useEffect(() => {
    //     // const getPermission = getRoleByPermission?.length > 0 ? getRoleByPermission : getPermissionLocal;
    //     const getPermission = getRoleByPermission;
    //     const permission = getPermission?.find((item) => item?.pageName === pageName);
    //     if (!permission) {
    //         navigate("/access-denied")
    //     }
    //     // eslint-disable-next-line 
    // }, [])

    useEffect(() => {
        // Permissions are loaded during dashboard bootstrap.
        // Avoid calling /admin/token again from this component.
        if (!getRoleByPermission || getRoleByPermission.length === 0) {
            return;
        }
        const permission = getRoleByPermission?.find(item => item?.pageName === pageName);
        if (!permission) {
            navigate('/access-denied');
        }
    }, [getRoleByPermission, navigate, pageName]);

    return (
        <>{getRoleByPermission.length > 0 && component}</>
    )
}

export default RolePermission